import { useMemo } from "react";
import { inBrowser, getUrlExtname } from "@lilib/utils";
import useUnmount from "./useUnmount";
import usePreviousRef from "./usePreviousRef";
var mimes = {
  gif: "image/gif",
  png: "image/png",
  ico: "image/x-icon"
};
function getHead() {
  if (inBrowser) {
    return document.getElementsByTagName("head")[0];
  }
}
function getLink() {
  if (inBrowser) {
    return document.querySelector("link[rel*='icon']");
  }
}
function useFavicon(href, options) {
  var _ref = options || {},
    mime = _ref.mime,
    restore = _ref.restore;
  var prevHrefRef = usePreviousRef(href);
  var oldIconData = useMemo(function () {
    if (inBrowser) {
      var link = getLink();
      if (link) {
        return {
          type: link.type,
          rel: link.rel,
          href: link.href
        };
      }
    }
  }, []);
  if (inBrowser && href != null && href !== prevHrefRef.current) {
    var link = getLink() || document.createElement("link");
    link.href = href;
    link.rel = "shortcut icon";
    link.type = mime || mimes[getUrlExtname(href)] || mimes.ico;
    if (!getLink()) {
      var head = getHead();
      head === null || head === void 0 ? void 0 : head.appendChild(link);
    }
  }
  useUnmount(function () {
    if (inBrowser && restore) {
      if (oldIconData === undefined) {
        var _head = getHead();
        var _link = getLink();
        _link && (_head === null || _head === void 0 ? void 0 : _head.removeChild(_link));
      } else {
        var _link2 = getLink();
        if (_link2) {
          _link2.type = oldIconData.type;
          _link2.rel = oldIconData.rel;
          _link2.href = oldIconData.href;
        }
      }
    }
  });
}
export default useFavicon;